const isMailtoPath = (path: string) => path.trim().toLowerCase().startsWith('mailto:');

const mapStatusBoardHostnameToConsole = (hostname: string): string => {
  if (hostname.startsWith('local.')) {
    return `console.${hostname.slice('local.'.length)}`;
  }
  return hostname.replace(/^status\./, 'console.');
};

const getConsoleOriginForHelpdesk = (loc: Pick<Location, 'href'>): string => {
  const url = new URL(loc.href);
  const isLocal = url.hostname.startsWith('local.');
  url.hostname = mapStatusBoardHostnameToConsole(url.hostname);

  if (isLocal && url.port === '3000') {
    url.port = '';
  }

  return url.origin;
};

export const resolveHelpdeskMenuOpenUrl = (path: string): string => {
  const trimmed = path.trim();
  if (isMailtoPath(trimmed)) {
    return trimmed;
  }
  if (typeof window === 'undefined') {
    return trimmed;
  }

  const consoleOrigin = getConsoleOriginForHelpdesk(window.location);
  try {
    return new URL(trimmed, consoleOrigin).href;
  } catch {
    return trimmed;
  }
};
